(function () {
  const PICKER_SELECTOR = '[data-material-size-picker]';
  const MATERIAL_MAX_WIDTH_CM = {
    'Non-Woven Wallpaper': 155,
    'Textured Wallpaper': 102,
    'Textile Wallpaper': 102,
    'Peel & Stick Wallpaper': 155
  };

  const normalizeStandardRolls = (pricing) => {
    if (!pricing || !Array.isArray(pricing.materials)) return pricing;
    pricing.materials.forEach((material) => {
      if (!Array.isArray(material.sizes)) return;
      material.sizes.forEach((size) => {
        const legacyWidth = /\b51\s*x/i.test(String(size.label_cm || ''))
          || /\b20\s*''\s*x/i.test(String(size.label || ''));
        if (!legacyWidth) return;
        size.label_cm = String(size.label_cm || '').replace(/\b51\s*x/i, '102x');
        size.label = String(size.label || '').replace(/\b20\s*''\s*x/i, "40''x");
        size.width_cm = 102;
        size.price = Math.round(Number(size.price || 0) * 2);
      });
    });
    return pricing;
  };

  // Check if user is in a country that uses imperial units (US, UK, Canada)
  const usesImperial = () => {
    const country = window.Shopify && window.Shopify.country;
    return country === 'US' || country === 'GB' || country === 'CA';
  };

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  };

  // Format money with proper currency symbol
  const formatMoneyValue = (cents, format) => {
    if (Number.isNaN(Number(cents))) {
      return '';
    }
    const amount = (cents / 100).toFixed(2);
    const amountWithComma = amount.replace('.', ',');
    const amountNoDecimals = Math.round(cents / 100).toString();

    return (format || '${{amount}}')
      .replace('{{amount}}', amount)
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals}}', amountNoDecimals);
  };

  // Helper to create SVG checkmark
  const createCheckmark = () => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.classList.add('picker-button-check');
    svg.setAttribute('viewBox', '0 0 20 20');
    svg.setAttribute('fill', 'currentColor');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('fill-rule', 'evenodd');
    path.setAttribute('d', 'M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z');
    path.setAttribute('clip-rule', 'evenodd');
    svg.appendChild(path);
    return svg;
  };

  // Renders buttons for Materials
  const renderMaterialButtons = (container, materials, selectElement) => {
    container.innerHTML = '';
    if (!materials || !materials.length) return;

    materials.forEach((material) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'picker-button';
      btn.dataset.value = material.label || material.name || material.id;

      const labelSpan = document.createElement('span');
      labelSpan.className = 'picker-button-label';
      labelSpan.textContent = material.label || material.name;

      btn.appendChild(createCheckmark());
      btn.appendChild(labelSpan);

      btn.addEventListener('click', () => {
        selectElement.value = btn.dataset.value;
        selectElement.dispatchEvent(new Event('change'));
      });

      container.appendChild(btn);
    });
  };

  // Updates the visual 'is-selected' state of buttons
  const updateButtonStates = (container, selectedValue) => {
    if (!container) return;
    const buttons = container.querySelectorAll('.picker-button');
    buttons.forEach(btn => {
      if (btn.dataset.value === selectedValue) {
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('is-selected');
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  };

  const populateMaterialOptions = (select, materials, placeholder) => {
    if (!select) {
      return;
    }
    const prompt = placeholder || 'Malzeme seçin';
    select.innerHTML = '';
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = prompt;
    defaultOption.selected = true;
    defaultOption.disabled = true;
    select.appendChild(defaultOption);

    materials.forEach((material) => {
      const option = document.createElement('option');
      option.value = material.label || material.name || material.id;
      option.dataset.materialId = material.id;
      option.textContent = option.value;
      select.appendChild(option);
    });
  };

  const populateSizeOptions = (select, material, placeholder, moneyFormat, currencyRate) => {
    if (!select) {
      return;
    }

    const prompt = placeholder || 'Ölçü seçin';
    select.innerHTML = '';
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = prompt;
    defaultOption.selected = true;
    defaultOption.disabled = true;
    select.appendChild(defaultOption);

    if (!material || !Array.isArray(material.sizes) || !material.sizes.length) {
      select.disabled = true;
      return;
    }

    material.sizes.forEach((size) => {
      const option = document.createElement('option');
      const width = size.width_cm || size.width || '';
      const height = size.height_cm || size.height || '';
      const hasDimensions = width && height;
      const fallbackLabel = hasDimensions ? `${width} x ${height} cm` : '';
      // Use inch label for US, cm label for other countries
      const label = usesImperial() ? (size.label || fallbackLabel || size.id || 'Size option') : (size.label_cm || size.label || fallbackLabel || size.id || 'Size option');
      option.value = label;
      option.dataset.sizeCode = size.id || '';
      option.dataset.price = Number(size.price || 0);
      if (width) {
        option.dataset.width = width;
      }
      if (height) {
        option.dataset.height = height;
      }
      const displayPrice = Math.round(size.price * (currencyRate || 1));
      const priceSuffix = size.price ? ` • ${formatMoneyValue(displayPrice, moneyFormat)}` : '';
      option.textContent = `${label}${priceSuffix}`;
      select.appendChild(option);
    });

    // Add Custom Size option
    const customOption = document.createElement('option');
    customOption.value = 'CUSTOM_SIZE';
    customOption.dataset.custom = 'true';
    customOption.dataset.pricePerSqm = material.price_per_sqm || 0;
    customOption.textContent = 'Özel Ölçü (ölçülerinizi girin)';
    select.appendChild(customOption);

    select.disabled = false;
  };

  const resetPriceDisplay = (targets, originals, summaryPrice, priceProperty) => {
    if (summaryPrice) {
      summaryPrice.textContent = '—';
    }
    if (priceProperty) {
      priceProperty.value = '';
    }
    targets.forEach((node, index) => {
      node.innerHTML = originals[index];
    });
  };

  const applyPriceDisplay = (targets, valueUSD, moneyFormat, currencyRate, summaryPrice, priceProperty, customPriceProperty, customPriceUsdProperty) => {
    // valueUSD is in USD cents (base currency)
    // Convert to display currency
    const displayCents = Math.round(valueUSD * (currencyRate || 1));
    const formatted = formatMoneyValue(displayCents, moneyFormat);
    if (summaryPrice) {
      summaryPrice.textContent = formatted;
    }
    if (priceProperty) {
      priceProperty.value = formatted;
    }
    if (customPriceProperty) {
      // Cart Transform expects price in presentment (display) currency
      customPriceProperty.value = displayCents;
    }
    if (customPriceUsdProperty) {
      // Canonical USD cents — lets the cart re-convert on market change.
      customPriceUsdProperty.value = Math.round(valueUSD);
    }
    targets.forEach((node) => {
      node.innerHTML = formatted;
    });
  };

  const initPicker = (picker) => {
    const sourceId = picker.getAttribute('data-pricing-source');
    const dataElement = sourceId ? document.getElementById(sourceId) : null;
    if (!dataElement) {
      console.warn('Material/Size pricing data element missing.');
      return;
    }

    let data;
    try {
      data = normalizeStandardRolls(JSON.parse(dataElement.textContent));
      window.__dkSamplePriceCents = Number(data.sample_price) || 20000;
    } catch (error) {
      console.error('Material/Size pricing JSON is invalid.', error);
      return;
    }

    if (!data || !Array.isArray(data.materials) || !data.materials.length) {
      console.warn('Material/Size pricing list is empty.');
      return;
    }

    const materialSelect = picker.querySelector('[data-material-select]');
    const sizeSelect = picker.querySelector('[data-size-select]');

    // Containers
    const materialButtonsContainer = picker.querySelector('[data-material-buttons]');

    // Description Element
    const descriptionElement = picker.querySelector('[data-material-description]');

    // Sample Button
    const sampleButton = picker.querySelector('[data-order-sample]');

    // Custom Dimensions
    const customDimensionsContainer = picker.querySelector('[data-custom-dimensions]');
    const customWidthInput = picker.querySelector('[data-custom-width]');
    const customHeightInput = picker.querySelector('[data-custom-height]');
    const customWidthLabel = picker.querySelector('[data-custom-width-label]');
    const widthWarning = picker.querySelector('[data-width-warning]');
    const widthWarningLimit = picker.querySelector('[data-width-warning-limit]');

    if (!materialSelect || !sizeSelect) {
      return;
    }

    const summaryMaterial = picker.querySelector('[data-selected-material]');
    const summarySize = picker.querySelector('[data-selected-size]');
    const summaryPrice = picker.querySelector('[data-calculated-price]');
    const helperText = picker.querySelector('[data-size-price-note]');
    const priceProperty = picker.querySelector('[data-price-property]');
    const customPriceProperty = picker.querySelector('[data-custom-price-property]');
    const customPriceUsdProperty = picker.querySelector('[data-custom-price-usd-property]');
    const materialCodeInput = picker.querySelector('[data-material-code-input]');
    const sizeCodeInput = picker.querySelector('[data-size-code-input]');
    const materialPropertyInput = picker.querySelector('[data-material-property]');
    const sizePropertyInput = picker.querySelector('[data-size-property]');
    const moneyFormat = picker.getAttribute('data-money-format') || '${{amount}}';
    // Try Shopify.currency.rate first, then fall back to data attribute
    const currencyRate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate)
      ? parseFloat(window.Shopify.currency.rate)
      : (parseFloat(picker.getAttribute('data-currency-rate')) || 1);
    const sectionId = picker.getAttribute('data-section-id');
    const formId = picker.getAttribute('data-product-form');
    const productForm = formId ? document.getElementById(formId) : null;
    const addToCartButton = picker.querySelector('[data-add-to-cart]');
    const addButton = addToCartButton || (productForm ? productForm.querySelector('.product-form__submit') : null);

    let currentMaterial = null;

    const getMaxWidthCm = () => {
      if (!currentMaterial) return 155;
      return Number(currentMaterial.max_width_cm) || MATERIAL_MAX_WIDTH_CM[currentMaterial.id] || 102;
    };

    const parseCmInput = (input) => {
      if (!input) return 0;
      if (window.DuvarkaplaMeasurements) {
        return window.DuvarkaplaMeasurements.parseCm(input.value) || 0;
      }
      return parseFloat(String(input.value || '').replace(',', '.')) || 0;
    };

    const updateCustomDimensionRules = () => {
      const maxWidthCm = getMaxWidthCm();
      if (customWidthInput) customWidthInput.max = String(maxWidthCm);
      if (customWidthLabel) customWidthLabel.textContent = `En (m veya cm, maks. ${maxWidthCm} cm)`;
      if (widthWarningLimit) widthWarningLimit.textContent = `${maxWidthCm} cm`;
    };

    const priceWrapper = sectionId ? document.getElementById(`price-${sectionId}`) : null;
    const priceTargets = priceWrapper ? Array.from(priceWrapper.querySelectorAll('.price-item--regular')) : [];
    const priceOriginals = priceTargets.map((node) => node.innerHTML);

    // Initial Population
    populateMaterialOptions(materialSelect, data.materials, picker.getAttribute('data-material-placeholder'));

    if (materialButtonsContainer) {
      renderMaterialButtons(materialButtonsContainer, data.materials, materialSelect);
    }

    // Initial Helper Text Logic
    if (helperText) {
      helperText.style.display = 'block';
      helperText.textContent = 'Önce malzeme seçin.';
    }

    // Reset summary price placeholder (default value was set for no-JS/Google bot)
    if (summaryPrice) {
      summaryPrice.textContent = '—';
    }

    // Auto-select Non-Woven Wallpaper and cheapest size on load
    const autoSelectDefaults = () => {
      // Find Non-Woven Wallpaper
      const nonWovenOption = Array.from(materialSelect.options).find(opt =>
        opt.dataset.materialId === 'Non-Woven Wallpaper'
      );

      if (nonWovenOption) {
        materialSelect.value = nonWovenOption.value;
        materialSelect.dispatchEvent(new Event('change'));

        // After material is selected, auto-select the first (cheapest) size
        setTimeout(() => {
          if (sizeSelect.options.length > 1) {
            // Select the first actual size option (index 1, since 0 is placeholder)
            sizeSelect.selectedIndex = 1;
            sizeSelect.dispatchEvent(new Event('change'));
          }
        }, 50);
      }
    };

    const updateButtonState = () => {
      // Keep Add to Cart button always enabled for Google Merchant compatibility
      // Validation happens on form submit

      if (sampleButton) {
        // Enable SAMPLE button if material is selected
        sampleButton.disabled = !materialSelect.value;
      }
    };

    materialSelect.addEventListener('change', () => {
      const selectedOption = materialSelect.options[materialSelect.selectedIndex];
      const materialId = selectedOption ? selectedOption.getAttribute('data-material-id') : '';
      currentMaterial = data.materials.find((item) => item.id === materialId);
      updateCustomDimensionRules();

      // Save current size state before re-populating
      const wasCustomSize = sizeSelect.value === 'CUSTOM_SIZE';
      const savedSizeValue = sizeSelect.value;
      const savedWidth = customWidthInput ? customWidthInput.value : '';
      const savedHeight = customHeightInput ? customHeightInput.value : '';

      // ── Immediate, cheap updates → instant tap feedback (low INP) ──
      if (summaryMaterial) {
        summaryMaterial.textContent = materialSelect.value || '—';
      }
      if (materialPropertyInput) {
        materialPropertyInput.value = materialSelect.value || '';
      }
      if (materialCodeInput) {
        materialCodeInput.value = currentMaterial ? currentMaterial.id : '';
      }
      updateSampleMaterialLabel();
      updateButtonStates(materialButtonsContainer, materialSelect.value);
      if (helperText) {
        helperText.style.display = 'none'; // Hide "Select material" helper
      }

      // ── Heavy work (description, full size-select rebuild + money
      //    formatting, price calc) deferred past the next paint so the tap
      //    feels instant. This is the main INP win on product pages. ──
      const applyMaterialDetails = () => {
        // Update Description
        if (descriptionElement) {
          if (currentMaterial && currentMaterial.description) {
            descriptionElement.innerHTML = currentMaterial.description.replace(/^([^:]+:)/, '<b>$1</b>');
            descriptionElement.style.display = 'block';
          } else {
            descriptionElement.style.display = 'none';
            descriptionElement.textContent = '';
          }
        }

        // Re-populate size select (Dropdown)
        populateSizeOptions(sizeSelect, currentMaterial, picker.getAttribute('data-size-placeholder'), moneyFormat, currencyRate);

        // Try to restore the previously selected size
        let sizeRestored = false;

        if (wasCustomSize) {
          // Restore custom size
          sizeSelect.value = 'CUSTOM_SIZE';
          if (customWidthInput) customWidthInput.value = savedWidth;
          if (customHeightInput) customHeightInput.value = savedHeight;

          // Show custom dimensions and recalculate
          if (customDimensionsContainer) {
            customDimensionsContainer.classList.add('active');
          }
          calculateCustomPrice();
          sizeRestored = true;
        } else if (savedSizeValue) {
          // Try to find and select the same size in the new options
          const matchingOption = Array.from(sizeSelect.options).find(opt => opt.value === savedSizeValue);
          if (matchingOption) {
            sizeSelect.value = savedSizeValue;
            sizeSelect.dispatchEvent(new Event('change'));
            sizeRestored = true;
          }
        }

        if (!sizeRestored) {
          if (summarySize) {
            summarySize.textContent = '—';
          }
          if (sizeCodeInput) {
            sizeCodeInput.value = '';
          }
          resetPriceDisplay(priceTargets, priceOriginals, summaryPrice, priceProperty);
        }

        updateButtonState();
      };

      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(applyMaterialDetails);
      } else {
        applyMaterialDetails();
      }
    });

    sizeSelect.addEventListener('change', () => {
      const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      const isCustom = selectedOption && selectedOption.dataset.custom === 'true';

      // Show/hide custom dimensions
      if (customDimensionsContainer) {
        if (isCustom) {
          customDimensionsContainer.classList.add('active');
        } else {
          customDimensionsContainer.classList.remove('active');
        }
      }

      if (isCustom) {
        // Custom size selected - calculate based on inputs
        calculateCustomPrice();
      } else {
        // Pre-made size selected
        const selectedPrice = selectedOption ? Number(selectedOption.getAttribute('data-price')) : 0;
        if (summarySize) {
          summarySize.textContent = selectedOption ? selectedOption.value : '—';
        }
        if (sizePropertyInput) {
          sizePropertyInput.value = selectedOption ? selectedOption.value : '';
        }
        if (sizeCodeInput) {
          sizeCodeInput.value = selectedOption ? selectedOption.getAttribute('data-size-code') || '' : '';
        }
        if (selectedPrice > 0) {
          applyPriceDisplay(priceTargets, selectedPrice, moneyFormat, currencyRate, summaryPrice, priceProperty, customPriceProperty, customPriceUsdProperty);
        } else {
          resetPriceDisplay(priceTargets, priceOriginals, summaryPrice, priceProperty);
        }
      }

      updateButtonStates(materialButtonsContainer, materialSelect.value);
      updateButtonState();
    });

    // Calculate custom price based on dimensions
    const calculateCustomPrice = () => {
      const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      const pricePerSqm = Number(selectedOption ? selectedOption.dataset.pricePerSqm : 0);
      const widthCm = parseCmInput(customWidthInput);
      const heightCm = parseCmInput(customHeightInput);
      const maxWidthCm = getMaxWidthCm();

      const clearCustomSelection = () => {
        resetPriceDisplay(priceTargets, priceOriginals, summaryPrice, priceProperty);
        if (customPriceProperty) customPriceProperty.value = '';
        if (customPriceUsdProperty) customPriceUsdProperty.value = '';
        if (summarySize) summarySize.textContent = '—';
        if (sizePropertyInput) sizePropertyInput.value = '';
        if (sizeCodeInput) sizeCodeInput.value = '';
      };

      // Check width limit
      if (widthCm > maxWidthCm) {
        if (widthWarning) {
          widthWarning.style.display = 'block';
        }
        clearCustomSelection();
        updateButtonState();
        return;
      } else {
        if (widthWarning) {
          widthWarning.style.display = 'none';
        }
      }

      if (widthCm > 0 && heightCm > 0 && pricePerSqm > 0) {
        const widthM = widthCm / 100;
        const heightM = heightCm / 100;
        const areaSqM = widthM * heightM;
        const totalPriceCents = Math.round(areaSqM * pricePerSqm);

        const sizeLabel = `${widthCm} × ${heightCm} cm`;
        if (summarySize) {
          summarySize.textContent = sizeLabel;
        }
        if (sizePropertyInput) {
          sizePropertyInput.value = sizeLabel;
        }
        if (sizeCodeInput) {
          sizeCodeInput.value = `CUSTOM-${widthCm}x${heightCm}CM`;
        }

        applyPriceDisplay(priceTargets, totalPriceCents, moneyFormat, currencyRate, summaryPrice, priceProperty, customPriceProperty, customPriceUsdProperty);
      } else {
        clearCustomSelection();
      }

      updateButtonState();
    };

    // Custom dimension inputs
    if (customWidthInput) {
      customWidthInput.addEventListener('input', calculateCustomPrice);
    }
    if (customHeightInput) {
      customHeightInput.addEventListener('input', calculateCustomPrice);
    }

    // Sample Button Logic
    // Echo the chosen material on the sample button (shoppers were ordering
    // the default material's sample by mistake).
    function updateSampleMaterialLabel() {
      const el = picker.querySelector('[data-sample-material]');
      if (!el) return;
      el.textContent = currentMaterial ? (currentMaterial.label || currentMaterial.id) + ' ' : '';
    }

    const selectMaterialById = (id) => {
      const opt = Array.from(materialSelect.options).find(
        (o) => o.getAttribute('data-material-id') === id
      );
      if (opt) {
        materialSelect.value = opt.value;
        materialSelect.dispatchEvent(new Event('change'));
      }
    };

    const addSampleToCart = async () => {
      if (!currentMaterial) return;

      const variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
      const variantId = variantInput ? variantInput.value : null;

      if (!variantId) {
        console.error('Variant ID not found');
        return;
      }

      sampleButton.classList.add('loading');
      sampleButton.textContent = 'Ekleniyor...';

      const formData = {
        'items': [{
          'id': variantId,
          'quantity': 1,
          'properties': {
            'Material': currentMaterial.label,
            'Size': 'Numune (A4)',
            '_custom_price': (window.__dkSamplePriceCents || 20000),
            '_Calculated price': formatMoneyValue(Math.round((window.__dkSamplePriceCents || 20000) * currencyRate), moneyFormat),
            'Material code': currentMaterial.id,
            'Size code': 'SAMPLE'
          }
        }]
      };

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (response.ok) {
          // Redirect to cart or open drawer
          window.location.href = '/cart';
        } else {
          console.error('Error adding to cart:', await response.text());
          sampleButton.textContent = 'Hata';
        }
      } catch (err) {
        console.error('Fetch error:', err);
        sampleButton.textContent = 'Error';
      } finally {
        sampleButton.classList.remove('loading');
      }
    };

    if (sampleButton) {
      // Confirm the material before adding the sample.
      sampleButton.addEventListener('click', () => {
        if (!currentMaterial) return;
        if (window.DKSampleConfirm) {
          window.DKSampleConfirm.open({
            materials: data.materials.map((m) => ({ id: m.id, label: m.label || m.id, popular: m.popular === true })),
            currentId: currentMaterial ? currentMaterial.id : null,
            priceText: formatMoneyValue(window.__dkSamplePriceCents || 20000, moneyFormat),
            onSelect: (id) => selectMaterialById(id),
            onConfirm: (id) => {
              if (id) selectMaterialById(id);
              addSampleToCart();
            }
          });
        } else {
          addSampleToCart();
        }
      });
    }

    // Quantity Controls
    const quantityInput = picker.querySelector('[data-quantity-input]');
    const quantityValue = picker.querySelector('[data-quantity-value]');
    const quantityMinus = picker.querySelector('[data-quantity-minus]');
    const quantityPlus = picker.querySelector('[data-quantity-plus]');

    let currentQuantity = 1;

    const updateQuantity = (newQty) => {
      if (newQty < 1) newQty = 1;
      currentQuantity = newQty;
      if (quantityValue) quantityValue.textContent = currentQuantity;
      if (quantityInput) quantityInput.value = currentQuantity;
      if (quantityMinus) quantityMinus.disabled = currentQuantity <= 1;
    };

    if (quantityMinus) {
      quantityMinus.addEventListener('click', () => {
        updateQuantity(currentQuantity - 1);
      });
    }

    if (quantityPlus) {
      quantityPlus.addEventListener('click', () => {
        updateQuantity(currentQuantity + 1);
      });
    }

    updateQuantity(1);
    updateButtonState();

    // Update sample button price display
    const updateSamplePrice = () => {
      if (!sampleButton) return;
      const priceSpan = sampleButton.querySelector('[data-sample-price]');
      if (!priceSpan) return;
      const samplePriceDisplay = window.__dkSamplePriceCents || 20000;
      priceSpan.textContent = formatMoneyValue(samplePriceDisplay, moneyFormat);
    };
    updateSamplePrice();

    // Auto-select defaults after initialization
    autoSelectDefaults();

    // Form submit - AJAX with Klaviyo/Pinterest/Shopify analytics tracking
    if (productForm) {
      productForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        if (!materialSelect.value || !sizeSelect.value) {
          if (helperText) {
            helperText.style.display = 'block';
            helperText.textContent = 'Lütfen malzeme ve ölçü seçin';
            helperText.style.color = '#e94560';
          }
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        const selectedSizeOption = sizeSelect.options[sizeSelect.selectedIndex];
        const isCustomSize = selectedSizeOption && selectedSizeOption.dataset.custom === 'true';
        if (isCustomSize) {
          const widthCm = parseCmInput(customWidthInput);
          const heightCm = parseCmInput(customHeightInput);
          const maxWidthCm = getMaxWidthCm();
          if (widthCm < 51 || widthCm > maxWidthCm || heightCm < 51 || !customPriceProperty || !customPriceProperty.value) {
            if (helperText) {
              helperText.style.display = 'block';
              helperText.textContent = `Özel ölçü için eni 51–${maxWidthCm} cm, boyu en az 51 cm girin.`;
              helperText.style.color = '#e94560';
            }
            picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
        }

        const addButton = picker.querySelector('[data-add-to-cart]');
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Ekleniyor...';
        }

        try {
          const formData = new FormData(productForm);
          const config = {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          };

          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', config);
          const cartData = await response.json();

          if (response.ok) {
            // Fire Shopify analytics event for Klaviyo/Pinterest/Google
            if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
              window.Shopify.analytics.publish('product_added_to_cart', {
                cartLine: {
                  merchandise: {
                    product: {
                      id: picker.dataset.productId || '',
                      title: picker.dataset.productTitle || document.querySelector('.product__title')?.textContent?.trim() || '',
                      vendor: picker.dataset.productVendor || '',
                      type: picker.dataset.productType || ''
                    }
                  },
                  quantity: parseInt(formData.get('quantity')) || 1,
                  cost: { totalAmount: { amount: cartData.price / 100, currencyCode: window.Shopify.currency?.active || 'USD' } }
                }
              });
            }

            // Fire Klaviyo Added to Cart event directly
            if (window.klaviyo) {
              window.klaviyo.push(['track', 'Added to Cart', {
                '$value': cartData.price / 100,
                'ProductName': cartData.product_title,
                'ProductID': cartData.product_id,
                'VariantID': cartData.variant_id,
                'Quantity': cartData.quantity,
                'ImageURL': cartData.featured_image?.url || '',
                'ProductURL': window.location.href
              }]);
            }

            // Update cart notification/drawer
            const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (cartNotification) {
              const sectionsUrl = window.location.pathname;
              const sections = cartNotification.getSectionsToRender ? cartNotification.getSectionsToRender().map(s => s.id).join(',') : '';
              if (sections) {
                const sectionResponse = await fetch(sectionsUrl + '?sections=' + sections);
                const sectionData = await sectionResponse.json();
                cartData.sections = sectionData;
              }
              if (cartNotification.renderContents) cartNotification.renderContents(cartData);
            } else {
              window.location.href = window.Shopify.routes.root + 'cart';
            }
          } else {
            if (helperText) {
              helperText.style.display = 'block';
              helperText.textContent = cartData.description || 'Sepete eklenirken bir hata oluştu';
              helperText.style.color = '#e94560';
            }
          }
        } catch (err) {
          console.error('Add to cart error:', err);
        } finally {
          if (addButton) {
            addButton.disabled = false;
            addButton.textContent = 'Sepete Ekle';
          }
        }
      });
    }
  };

  onReady(() => {
    document.querySelectorAll(PICKER_SELECTOR).forEach((picker) => {
      initPicker(picker);
    });
  });
})();
